// PostgreSQL liefert bigint (COUNT, SUM) und numeric (ROUND, AVG) ueber node-pg
// als *Strings* aus, damit keine Praezision verlorengeht. Recharts erwartet auf
// einer numerischen Achse aber echte Zahlen: Bekommt es Strings, faellt die
// Domain-Berechnung auf einen Stringvergleich zurueck - und dabei gilt "900"
// als groesser als "1221", weil lexikografisch verglichen wird.
//
// Folge: Die Y-Achse endet unterhalb des tatsaechlichen Maximums, Flaeche und
// Linie laufen oben aus dem Plotbereich heraus. Sichtbar wird das genau dann,
// wenn sich die Stellenzahl der Werte unterscheidet - also "wenn ein Wert
// klein ist".

const asList = (keys) => (Array.isArray(keys) ? keys : [keys]);

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

// Wandelt die angegebenen Felder jeder Zeile in Zahlen um. Fehlende Werte
// bleiben null, damit Recharts dort eine Luecke zeichnet statt eines Abfalls
// auf die Nulllinie.
//
// Fuer eine sichtbare Achse reicht das allein: Recharts' Standard-Domain
// [0, "auto"] rundet dann selbst auf einen glatten Wert oberhalb des Maximums
// auf - das kann es gut, und die Ticks bleiben lesbar.
export const toNumericSeries = (data, keys) => {
  if (!Array.isArray(data)) return [];
  const fields = asList(keys);

  return data.map((entry) => {
    const next = { ...entry };
    fields.forEach((key) => {
      next[key] = toFiniteNumber(entry?.[key]);
    });
    return next;
  });
};

// Explizite Domain mit Luft nach oben - gedacht fuer Diagramme mit
// *ausgeblendeter* Achse, bei denen Recharts' automatische Aufrundung nicht
// greift oder zusaetzlicher Platz gebraucht wird, etwa fuer Wertlabels ueber
// den Punkten.
//
// Bewusst ohne Rundung auf glatte Werte: Ohne sichtbare Ticks bringt das
// nichts und verschenkt nur Hoehe - eine Aufrundung von 5.231 auf 8.000 haette
// ein Drittel des Plotbereichs leer gelassen und die Kurve wieder flachgedrueckt.
//
// Untergrenze ist 0: Bei einer Flaechendarstellung leitet das Auge die Groesse
// aus der Flaeche ab, eine abgeschnittene Achse wuerde die Verhaeltnisse
// verzerren.
export const domainWithHeadroom = (data, keys, headroom = 0.15) => {
  const fields = asList(keys);
  const values = (Array.isArray(data) ? data : [])
    .flatMap((entry) => fields.map((key) => toFiniteNumber(entry?.[key])))
    .filter((value) => value !== null);

  if (!values.length) return [0, 1];

  const max = Math.max(...values);
  if (max <= 0) return [0, 1];

  return [0, max * (1 + headroom)];
};
